// requires that parsley be loaded already
import 'parsleyjs';

window.parsleyEmailValidated = false;
window.Parsley.addAsyncValidator(
  'validateEmailAddress', function (xhr) {
    if (xhr.status == '404') {
      let response = $.parseJSON(xhr.responseText);
      if (window.parsleyEmailValidated) {
        this.updateError('user_email-error', {message: response.error});
      } else {
        window.parsleyEmailValidated = true;
        this.addError('user_email-error', {message: response.error});
      }
    }
    return xhr.status >= 200 && xhr.status < 300; // returning false triggers the default validation to display again
  }
).on('field:validate', function () {
  if (!['modal_user_email', 'user_email'].includes(this.$element.attr('id'))) return;
  this.removeError('serverError');  // we now have server-side email validation, so need to clean up
  if (this.getErrorsMessages().length) {
    this.removeError('user_email-error');
    window.parsleyEmailValidated = false;
  }
}).on('field:error', function() {
  if (window.parsleyEmailValidated) {
    $('.parsley-remote').remove();
  }
});

window.Parsley.addValidator('nameValidate', {
    requirementType: 'string',
    validateString: function(value) {
      const regex = /^([^0-9]*)$/g;
      return regex.test(value);
    },
    messages: {
      en: 'Name must not contain numeric values'
    }
});

jQuery(() => {
  if ($('#user_phone, .user-phone').length) {
    import('javascripts/gitb_intl_tel_input');
  }
});